var dataAction = (function () {
	//TODO: move url to point at RestBundle
	var restUrl = CONFIGURATION.REST_URL;
	var url = CONFIGURATION.CLIENT_SERVICE_URL;
	var adminUrl = CONFIGURATION.SERVICE_URL;

	function callClientGetEndpoint(endpoint, success, error, complete) {
		$.ajax({
			url: CONFIGURATION.SERVICE_URL + endpoint,
			type: "GET",
			success: success,
			error: error,
			complete: complete
		});
	}

	function callClientPostEndpoint(endpoint, data, success, error, complete) {
		$.ajax({
			url: CONFIGURATION.SERVICE_URL + endpoint,
			type: "POST",
			data: data,
			success: success,
			error: error,
			complete: complete
		});
	}

	function editComment(data, success, error, complete) {
		$.ajax({
			url: url + '/idea/editComment/' + data.commentId,
			type: "POST",
			data: data,
			success: success,
			error: error,
			complete: complete
		});
	}

	function submitComment(data, success, error, complete) {
		$.ajax({
			url: url + '/idea/submitComment/' + data.ideaId,
			type: "POST",
			data: data,
			success: success,
			error: error,
			complete: complete
		});
	}

	function updateCustomField(data, success, error, complete) {
		$.ajax({
			url: adminUrl + '/admin/settings/updateCustomField',
			type: "POST",
			data: data,
			success: success,
			error: error,
			complete: complete
		});
	}

	function deleteCustomField(data, success, error, complete) {
		$.ajax({
			url: adminUrl + '/admin/settings/deleteCustomField',
			type: "POST",
			contentType: "application/json",
			data: JSON.stringify(data),
			success: success,
			error: error,
			complete: complete
		});
	}

	function generatePassword(data, success, error, complete) {
		$.ajax({
			url: adminUrl + '/admin/user/generatePassword',
			type: "POST",
			data: data,
			success: success,
			error: error,
			complete: complete
		});
	}

	function disableUser(data, success, error, complete) {
		$.ajax({
			url: adminUrl + '/admin/user/updateUserState/' + data.id,
			type: "POST",
			data: data,
			success: success,
			error: error,
			complete: complete
		});
	}

	function enableUser(data, success, error, complete) {
		$.ajax({
			url: adminUrl + '/admin/user/updateUserState/' + data.id,
			type: "POST",
			data: data,
			success: success,
			error: error,
			complete: complete
		});
	}

	function disableUserAdmin(data, success, error, complete) {
		$.ajax({
			url: adminUrl + '/admin/user/toggleUserAdminLevel/' + data.id,
			type: "POST",
			data: data,
			success: success,
			error: error,
			complete: complete
		});
	}

	function enableUserAdmin(data, success, error, complete) {
		$.ajax({
			url: adminUrl + '/admin/user/toggleUserAdminLevel/' + data.id,
			type: "POST",
			data: data,
			success: success,
			error: error,
			complete: complete
		});
	}

	function challengeLock(data, success, error, complete) {
		$.ajax({
			url: adminUrl + '/admin/challenges/lockChallenge/' + data.id,
			type: "POST",
			data: data,
			success: success,
			error: error,
			complete: complete
		});
	}

	function challengeHide(data, success, error, complete) {
		$.ajax({
			url: adminUrl + '/admin/challenges/hideChallenge/' + data.id,
			type: "POST",
			data: data,
			success: success,
			error: error,
			complete: complete
		});
	}

	function moveChallenge(data, success, error, complete) {
		$.ajax({
			url: adminUrl + '/admin/challenges/changeChallengeOrder/' + data.id,
			type: "POST",
			data: data,
			success: success,
			error: error,
			complete: complete
		});
	}

	function resetPassword(data, success, error, complete) {
		$.ajax({
			url: url + '/reset-password',
			type: "POST",
			data: data,
			success: success,
			error: error,
			complete: complete
		});
	}

	function requestLoginLink(data, success, error, complete) {
		$.ajax({
			url: url + '/request-login-link',
			type: "POST",
			data: data,
			success: success,
			error: error,
			complete: complete
		});
	}

	function getCodifications(data, success, error, complete) {
		$.ajax({
			url: url + '/idea/getCodifications',
			type: "POST",
			contentType: "application/json",
			data: JSON.stringify(data),
			success: success,
			error: error,
			complete: complete
		});
	}

	function saveCodifications(data, success, error, complete) {
		$.ajax({
			url: url + '/idea/saveCodifications',
			type: "POST",
			contentType: "application/json",
			data: JSON.stringify(data),
			success: success,
			error: error,
			complete: complete
		});
	}

	function contactAuthor(data, success, error, complete) {
		$.ajax({
			url: url + '/idea/contactAuthor',
			type: "POST",
			data: data,
			success: success,
			error: error,
			complete: complete
		});
	}

	function updateUserProfile(data, success, error, complete) {
		$.ajax({
			url: restUrl + '/editUser',
			type: "POST",
			data: data,
			success: success,
			error: error,
			complete: complete
		});
	}

	function updateInvitationErrors(data, success, error, complete) {
		$.ajax({
			url: restUrl + '/settings/adjustInvitationErrors',
			type: "POST",
			data: data,
			success: success,
			error: error,
			complete: complete
		});
	}

	function sendTestEmail(data, success, error, complete) {
		$.ajax({
			url: restUrl + '/sendTestEmail',
			type: "POST",
			data: data,
			success: success,
			error: error,
			complete: complete
		});
	}

	function sendVerificationEmail(data, success, error, complete) {
		$.ajax({
			url: url + '/send-verification-email',
			type: "POST",
			data: data,
			success: success,
			error: error,
			complete: complete
		});
	}

	return {
		callClientGetEndpoint: callClientGetEndpoint,
		callClientPostEndpoint: callClientPostEndpoint,
		editComment: editComment,
		updateCustomField: updateCustomField,
		deleteCustomField: deleteCustomField,
		generatePassword: generatePassword,
		disableUser: disableUser,
		enableUser: enableUser,
		disableUserAdmin: disableUserAdmin,
		enableUserAdmin: enableUserAdmin,
		challengeLock: challengeLock,
		challengeHide: challengeHide,
		moveChallenge: moveChallenge,
		resetPassword: resetPassword,
		requestLoginLink: requestLoginLink,
		getCodifications: getCodifications,
		saveCodifications: saveCodifications,
		contactAuthor: contactAuthor,
		submitComment: submitComment,
		updateUserProfile: updateUserProfile,
		updateInvitationErrors: updateInvitationErrors,
		sendTestEmail: sendTestEmail,
		sendVerificationEmail: sendVerificationEmail

	};
}());